import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AttachmentInterface } from '../../../../../documents/attachments/attachment';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentComponent implements OnInit {
  @Input() attachment: AttachmentInterface;
  @Input() shareableId: string;

  constructor() {}

  ngOnInit() {}

  get url(): string {
    // https://api.spaceinvoices.com/v1/documents/public/{{ document.shareableId }}/attachments/{{ att.id }}/download

    const urlParts = this.attachment.url.split('containers');
    const baseUrl = urlParts[0];

    return (
      baseUrl +
      `documents/public/${this.shareableId}/attachments/${this.attachment.id}/download`
    );
  }
}
